import { render, staticRenderFns } from "./UsersAdministration.vue?vue&type=template&id=0c55b93a"
import script from "./UsersAdministration.vue?vue&type=script&lang=ts"
export * from "./UsersAdministration.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports